/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Custom_Page_Icon_ShieldiconInputs */

const en_enum_custom_page_icon_shieldicon = /** @type {(inputs: Enum_Custom_Page_Icon_ShieldiconInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shield`)
};

const de_enum_custom_page_icon_shieldicon = /** @type {(inputs: Enum_Custom_Page_Icon_ShieldiconInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schild`)
};

/**
* | output |
* | --- |
* | "Shield" |
*
* @param {Enum_Custom_Page_Icon_ShieldiconInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const enum_custom_page_icon_shieldicon = /** @type {((inputs?: Enum_Custom_Page_Icon_ShieldiconInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Custom_Page_Icon_ShieldiconInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_custom_page_icon_shieldicon(inputs)
	return de_enum_custom_page_icon_shieldicon(inputs)
});